import Vue from "vue";

const appStore = Vue.observable({
  loadingMessage: "Indlæser lasso..."
})
export default appStore;